import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';
import { renderAbsoluteAssets } from '../util/renderHelpers';
import Home from '../pages/Home';
import Photos from '../pages/Photos';
import { ThemeContext } from '../context';
import Footer from '../common/Footer';
import FixedWidthContainer from '../common/FixedWidthContainer';
import BaseComponent from '../common/BaseComponent';
import Hero from '../pages/Home/Hero';
import type { BaseLayoutProps } from './types';

const MultiPageLayout = ({ wedding, pageType, pageData }: BaseLayoutProps): JSX.Element => {
  const {
    container = {},
    homepage: { assets, border },
  } = useContext(ThemeContext);
  const { assets: containerAssets } = container;

  const { home, photos } = pageData || {};
  const { header_image_url, title } = home || {};

  const getPageContent = () => {
    switch (pageType) {
      case 'photo':
        return <Photos photosPageData={photos} />;
      default:
        return <Home wedding={wedding} homepageData={home} />;
    }
  };

  const StyledHero = styled(Hero)<{ isPaddedContent?: boolean }>`
    ${({ isPaddedContent }) =>
      isPaddedContent &&
      Boolean(header_image_url) &&
      `
        margin-top: 60px;
        ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
            margin-top: 20px;
        }
        `}
  `;

  const renderHeroSection = () => {
    const addPadding = false;
    if (addPadding) {
      return (
        <FixedWidthContainer>
          <StyledHero title={title} isPaddedContent={false} imageUrl={header_image_url} />
        </FixedWidthContainer>
      );
    }
    return (
      <div>
        <StyledHero title={title} isPaddedContent={false} imageUrl={header_image_url} />
      </div>
    );
  };

  const ContentContainer = styled.div`
    position: relative;
  `;

  // TODO: FIGURE OUT ASSETS
  return (
    <ContentContainer>
      {renderAbsoluteAssets(containerAssets)}
      {pageType === 'home' && renderHeroSection()}
      <BaseComponent assets={assets} border={border} componentKey="container">
        <FixedWidthContainer addPaddingTop={!(pageType === 'home' && Boolean(header_image_url))}>
          {getPageContent()}
          <Footer />
        </FixedWidthContainer>
      </BaseComponent>
    </ContentContainer>
  );
};

export default MultiPageLayout;
